export enum LoaderSize {
  sm = 20,
  md = 50,
  l = 100,
}

export enum LOGIN_PROVIDERS {
  GOOGLE = 'Google',
  MICROSOFT = 'Microsoft',
}

export enum SECTION_TYPE {
  MASS_CHANGES = 'massChanges',
}

export enum TABLE_CELL_TYPE {
  TEXT = 'text',
  DATE = 'date',
  SWITCH = 'switch',
  BUTTON = 'button',
  STATUS = 'status',
  USERNAME = 'username',
  USERS = 'users',
  EMAIL = 'email',
  EMAIL_WITH_USER_ID = 'emailWithUserId',
  NAME_ARRAY = 'nameArray',
  DATE_RANGE = 'dateRange',
  MULTI_SELECT = 'multiSelect',
  ID = 'id',
  ICON = 'icon',
  NUMBER = 'number',
  SELECT = 'select',
  PHONE_NUMBER = 'phoneNumber',
  GUID = 'guid',
  LINK = 'link',
  FILE_UPLOAD = 'FileUpload',
  CHECKBOX = 'Checkbox',
  ADMIN_ICONS_ARRAY = 'adminIconsArray',
  COMMENT = 'comment',
  NODE = 'node',
  HELIOS_VALUE = 'heliosValue',
  HELIOS_STATIC_SELECTION = 'heliosStaticSelection',
  HELIOS_BROWSE = 'heliosBrowse',
  HELIOS_FILE = 'heliosFile',
  HELIOS_LINK = 'heliosLink',
  HELIOS_BUTTON = 'heliosButton',
}

export enum TABLE_CELL_STATUS {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  INVITED = 'Invited',
  ARCHIVED = 'Archived',
  DESIGN = 'Návrh',
  DRAFT = 'Draft',
  ONLINE = 'Online',
  OFFLINE = 'Offline',
  UNKNOWN = 'Unknown',
  LOADING = 'Loading',
  NEW = 'New',
  IN_PROCESSS = 'InProcess',
  IMPORTED = 'Imported',
  SUCCESS = 'Success',
  FAILED = 'Failed',
  CREATED = 'Created',
  UPDATED = 'Updated',
}

export enum RestApiConnectionAuthType {
  None = 'None',
  BasicAuth = 'BasicAuth',
  TokenAuth = 'TokenAuth',
  // Phase 2: keep ApiKey and OAuth2 out of the UI until backend support lands.
  ApiKey = 'ApiKey',
  OAuth2 = 'OAuth2',
}

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  TRACE = 'TRACE',
  CONNECT = 'CONNECT',
}

export enum ApiLogLevel {
  None = 'None',
  Error = 'Error',
  All = 'All',
}

export enum UserPermissions {
  APPROVAL = 'Approval',
  ARCHIVING = 'Archiving',
  COMMENTING = 'Commenting',
  CREATION = 'Creation',
  DELETION = 'Deletion',
  EDITING = 'Editing',
  HISTORY = 'History',
  READING = 'Reading',
  RUN_FUNCTION = 'RunFunction',
}

export enum UserStatus {
  INVITED = 'Invited',
  INACTIVE = 'Inactive',
  ACTIVE = 'Active',
  BLANK = '',
}

export enum ACTIONS_ENUM {
  Create = 'create',
  Change = 'change',
  Notify = 'notify',
  DeleteNotification = 'deleteNotification',
  Archive = 'archive',
  Delete = 'delete',
  IncreaseVersion = 'increaseVersion',
  DistinctForeach = 'distinctForEach',
  CreateForEach = 'createForEach',
  SendDataToErp = 'sendDataToErp',
  TakeDataFromErp = 'takeDataFromErp',
  ExternalAction = 'externalAction',
  ExternalRestApi = 'externalRestApi',
  Redirect = 'redirect',
  GoToExternalCatalogue = 'goToExternalCatalogue',
  PurchaseExternalCatalogue = 'purchaseExternalCatalogue',
  SendDataToErpWithItems = 'sendDataToErpWithItems',
  Dialog = 'dialog',
  Halt = 'halt',
  Empty = '',
}

export const ACTIONS_CONFIG_PAYLOAD_ENUM = {
  [ACTIONS_ENUM.Create]: 'createAction',
  [ACTIONS_ENUM.Change]: 'changeAction',
  [ACTIONS_ENUM.Notify]: 'notifyAction',
  [ACTIONS_ENUM.DeleteNotification]: 'deleteNotificationAction',
  [ACTIONS_ENUM.Archive]: 'archiveAction',
  [ACTIONS_ENUM.Delete]: 'deleteAction',
  [ACTIONS_ENUM.IncreaseVersion]: 'increaseVersionAction',
  [ACTIONS_ENUM.DistinctForeach]: 'distinctForEachAction',
  [ACTIONS_ENUM.CreateForEach]: 'createForEachAction',
  [ACTIONS_ENUM.SendDataToErp]: 'sendDataToErpAction',
  [ACTIONS_ENUM.SendDataToErpWithItems]: 'sendDataToErpWithItemsAction',
  [ACTIONS_ENUM.TakeDataFromErp]: 'takeDataFromErpAction',
  [ACTIONS_ENUM.ExternalAction]: 'externalAction',
  [ACTIONS_ENUM.ExternalRestApi]: 'externalRestApi',
  [ACTIONS_ENUM.Redirect]: 'redirectAction',
  [ACTIONS_ENUM.GoToExternalCatalogue]: 'goToExternalCatalogueAction',
  [ACTIONS_ENUM.PurchaseExternalCatalogue]: 'purchaseExternalCatalogueAction',
  [ACTIONS_ENUM.Dialog]: 'dialogAction',
  [ACTIONS_ENUM.Halt]: 'haltAction',
};

export enum RECURRENCE_ENUM {
  HOURLY = 'Hourly',
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  YEARLY = 'Yearly',
  NEVER = 'Never',
}
export enum RECURRENCE_TYPE_ENUM {
  PATTERN_ONLY = 'PatternOnly',
  TIME_RANGED = 'TimeRanged',
  TIME_SPECIFIC = 'TimeSpecific',
}

export enum VISIBILITY_STATE {
  HIDDEN = 'Hidden',
  VISIBLE = 'Visible',
  EDITABLE = 'Editable',
}

export enum CHANGE_BEHAVIOR_OPTION {
  NONE = 'None',
  NOTIFY_USER_TO_SAVE = 'NotifyUserToSave',
  SAVE_REQUIRED = 'SaveRequired',
  CALCULATE = 'Calculate',
  RUN_ACTIONS_WITHOUT_SAVING = 'RunActionsWithoutSaving',
  SAVE_BUT_DO_NOT_RUN_ACTIONS = 'SaveButDoNotRunActions',
}

export enum PERSIST_TABLE_IDS {
  USER_AGENDA_TABLE = 'userAgendaTable',
  USER_AGENDA_CALENDAR = 'userAgendaCalendar',
  USER_HELIOS_TEMPLATE_TABLE = 'userHeliosTemplateTable',
  USER_HELIOS_RECORD_DETAIL_TABLE = 'userHeliosRecordDetailTable',
}

export enum USER_AGENDA_TABLE_PRESENTATION_MODE {
  AGENDA = 'agenda',
  NESTED_LIST = 'nested-list',
  PORTAL = 'portal',
}

export enum HELIOS_TYPE_ACCOUNT {
  USER_ACCOUNT = 'UserAccount',
  DEFAULT_AND_SERVICE_ACCOUNTS = 'DefaultAndServiceAccounts',
}

export enum VIEW_MODE {
  DIALOG = 'Dialog',
  NESTED_MAPPING = 'NestedListing',
  PORTAL = 'Portal',
}

export enum INTERACTION_TYPE {
  EDITING = 'Editing',
  CREATION = 'Creation',
  ADDITION = 'Addition',
}

export enum VIEW_ITEM_STATE {
  DISABLED_AND_NO_FILTER = 'DisabledAndNoFilter',
  ENABLED_AND_FILTER = 'EnabledAndFilter',
  ENABLED_AND_NO_FILTER = 'EnabledAndNoFilter',
  DISABLED_AND_FILTER = 'DisabledAndFilter',
}

export enum VIEW_TYPE {
  STANDARD = 'Standard',
  ACTION_FORM = 'ActionForm',
  CATALOGUE = 'Catalogue',
  CALENDAR = 'Calendar',
  USER_SETTINGS = 'UserSettings',
  SHOPPING_CART = 'ShoppingCart',
}

export enum DATA_STRUCTURE {
  HIERARCHICAL = 'Hierarchical',
  LINEAR = 'Linear',
}

export enum SUBSTITUTABILITY_LISTING_TYPE {
  NONE = 'None',
  ALL_USERS = 'AllUsers',
  ONE_USER_ROLE = 'OneUserRole',
  ALL_USER_ROLES = 'AllUserRoles',
}

export enum SUBSTITUTION_TYPE {
  NONE = 'None',
  ABSENCE = 'Absence',
  SUBSTITUTION = 'Substitution',
}

export enum DISPLAY_NESTED_LIST_COLUMNS {
  DO_NOT_DISPLAY = 'DoNotDisplay',
  DISPLAY_IN_FILTER = 'DisplayInFilter',
  DISPLAY_ALWAYS = 'DisplayAlways',
}

export enum RECORD_VERSION_CREATION_MODE {
  ALL_UPDATES = 'AllUpdates',
  UI_UPDATES_ONLY = 'UiUpdatesOnly',
  INCREASE_VERSION_ONLY = 'IncreaseVersionOnly',
}
